import { atom } from 'recoil';

import { SCREEN_HEIGHT } from '../constants';

export const AScreenHeight = atom<number>({
  key: SCREEN_HEIGHT,
  default: 0,
});
